export default "__VITE_ASSET__6e6e7a59__"